import {
  inputWidget,
  ButtonWidget,
  PasswordWidget,
} from "@/components/index";


const GlobalComponents = {
  install(Vue) {
    Vue.component("f-input", inputWidget);
    Vue.component("f-button", ButtonWidget);
    Vue.component("f-password", PasswordWidget);
  },
};

export default GlobalComponents;
